import React, { useEffect } from 'react';
import ProcessingModal from '@/components/dashboard-modal/ProcessingModal';
import { useAppIdeaGeneration } from '@/hooks/app-library/use-app-idea-generation';
import { RequestAppFormData } from './RequestAppModal';

interface AppIdeaGenerationModalProps {
  isOpen: boolean;
  onClose: () => void;
  requestData: RequestAppFormData | null;
  onSuccess: (ideaId: string) => void;
}

const AppIdeaGenerationModal: React.FC<AppIdeaGenerationModalProps> = ({
  isOpen,
  onClose,
  requestData,
  onSuccess,
}) => {
  const { state, startGeneration, reset } = useAppIdeaGeneration();

  useEffect(() => {
    if (isOpen && requestData && state.status === 'idle') {
      startGeneration(requestData);
    }
  }, [isOpen, requestData, startGeneration, state.status]);

  const handleClose = () => {
    reset();
    onClose();
  };
  
  const handleRetry = () => {
    if (requestData) {
      startGeneration(requestData);
    }
  };
  
  const handleSuccess = () => {
    if(state.generatedIdeaId) {
      onSuccess(state.generatedIdeaId);
    }
    handleClose();
  };

  return (
    <ProcessingModal
      isOpen={isOpen}
      onClose={handleClose}
      state={state.status === 'processing' ? 'processing' : state.status === 'success' ? 'success' : 'error'}
      tasks={state.tasks}
      progress={state.progress}
      currentTaskDescription={state.currentTaskDescription}
      errorMessage={state.error || ''}
      onRetry={handleRetry}
      successMessage="Your new app idea has been generated and saved!"
      successActionText="Continue"
      onSuccessAction={handleSuccess}
      title="Generating Your App Idea"
      description="Our AI is crafting a unique concept based on your problem."
    />
  );
};

export default AppIdeaGenerationModal;
